export default [
  'As Soon as Possible',
  'In a Month',
  'In a Quarter',
  'In a Year',
  'Not Sure'
];
